import { last } from "ramda"

export default function () {
    const mobileSearch = document.querySelector('.search-mobile')
    const mobileSearchOpen = document.querySelector('.nav-mobile-search')
    const mobileSearchClose = document.querySelector('.search-mobile-close')
    const mobileSearchFakeSubmit = document.querySelector('.search-mobile-fake-submit')
    const mobileSearchRealSubmit = document.querySelector('.search-mobile-real-submit')

    // mobileSearchOpen.addEventListener('click', ev => {
    //     mobileSearch.classList.remove('sr-only')
    // })
    // mobileSearchClose.addEventListener('click', ev => {
    //     mobileSearch.classList.add('sr-only')
    // })
    // mobileSearchFakeSubmit.addEventListener('click', ev => {
    //     mobileSearchRealSubmit.click()
    // })

    // Desktop
    // const headers = [...document.querySelectorAll('.header')]

    // headers.forEach(header => {
    //     const desktopSearch = header.querySelector('.header-search')
    //     const desktopSearchInput = header.querySelector('.header-search input')
    //     const desktopSearchOpen = header.querySelector('.header-search-open')
    //     const desktopSearchClose = header.querySelector('.header-search-close')
    //     const desktopSearchFakeSubmit = header.querySelector('.search-desktop-fake-submit')
    //     const desktopSearchRealSubmit = header.querySelector('.search-desktop-real-submit')
    //     const lastCTA =  document.querySelector('.header__btn a')
    //     let lastCtaWidth = parseInt(lastCTA.getBoundingClientRect().width / 1.1)
    //     desktopSearch.style.width = desktopSearch.getBoundingClientRect().width - lastCtaWidth + `px`
    //     desktopSearchOpen.addEventListener('click', ev => {
    //         header.classList.add('search-open')
    //         desktopSearch.classList.remove('hidden')
    //         desktopSearchInput.focus()
    //     })
    //     desktopSearchClose.addEventListener('click', ev => {
    //         header.classList.remove('search-open')
    //         desktopSearch.classList.add('hidden')
    //     })
    //     // desktopSearchFakeSubmit.addEventListener('click', ev => {
    //     //     desktopSearchRealSubmit.click()
    //     // })

    //     desktopSearchInput.addEventListener('keydown', ev => {
    //         if (ev.code === 'Escape') {
    //             header.classList.remove('search-open')
    //             desktopSearchClose.click()
    //         }
    //     })
    // })

}
